import { createContext, useContext, useState, useCallback } from "react";
import { CheckCircle2, XCircle, Info, X } from "lucide-react";

const ToastContext = createContext(null);
export const useToast = () => useContext(ToastContext);

const meta = {
  success: {
    icon: CheckCircle2,
    color: "#16a34a",
    bg: "#f0fdf4",
    border: "#bbf7d0",
  },
  error: { icon: XCircle, color: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
  info: { icon: Info, color: "#1e40af", bg: "#eff6ff", border: "#bfdbfe" },
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const push = useCallback((type, msg) => {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, type, msg }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3200);
  }, []);

  const toast = {
    success: (m) => push("success", m),
    error: (m) => push("error", m),
    info: (m) => push("info", m),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          gap: 10,
          pointerEvents: "none",
        }}
      >
        {toasts.map((t) => {
          const m = meta[t.type];
          const Icon = m.icon;
          return (
            <div
              key={t.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                minWidth: 280,
                maxWidth: 380,
                background: "#fff",
                border: `1px solid ${m.border}`,
                borderLeft: `4px solid ${m.color}`,
                borderRadius: 12,
                padding: "14px 16px",
                boxShadow: "0 8px 24px rgba(15,23,42,0.12)",
                fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
                pointerEvents: "auto",
                animation: "toastIn 0.25s cubic-bezier(0.21,1.02,0.73,1)",
              }}
            >
              <Icon size={20} color={m.color} style={{ flexShrink: 0 }} />
              <span
                style={{
                  flex: 1,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#0f172a",
                }}
              >
                {t.msg}
              </span>
              <X
                size={16}
                color="#94a3b8"
                style={{ cursor: "pointer", flexShrink: 0 }}
                onClick={() =>
                  setToasts((arr) => arr.filter((x) => x.id !== t.id))
                }
              />
            </div>
          );
        })}
      </div>
      <style>{`
        @keyframes toastIn {
          from { opacity: 0; transform: translateX(40px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </ToastContext.Provider>
  );
}
